import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, createVNode as _createVNode, mergeProps as _mergeProps } from "vue"

const _hoisted_1 = { class: "app-time-field" }
const _hoisted_2 = {
  key: 0,
  class: "field-label"
}

import { computed, ref, useAttrs, watch } from "vue";


export default /*@__PURE__*/_defineComponent({
  ...{
  inheritAttrs: false,
},
  __name: 'AppTimeField',
  props: /*@__PURE__*/_mergeModels({
    variant: { default: "solo" },
    flat: { type: Boolean, default: true },
    hideDetails: { type: [Boolean, String], default: "auto" },
    label: { default: "" },
    labelIcon: { default: "" }
  }, {
    "modelValue": {},
    "modelModifiers": {},
  }),
  emits: ["update:modelValue"],
  setup(__props: any) {



const model = _useModel<string | null>(__props, "modelValue");

const props = __props;

const attrs = useAttrs();
const showMenu = ref(false);

const fieldClass = computed(() => ["app-time-field__input", attrs.class]);
const fieldAttrs = computed(() => {
  const { class: _class, ...rest } = attrs;
  return rest;
});

const displayValue = computed(() => formatTime(model.value));

watch(model, () => {
  if (showMenu.value && model.value) {
    showMenu.value = false;
  }
});

function formatTime(value: string | null) {
  if (!value) return "";
  const raw = String(value).trim();
  if (!raw.includes(":")) return raw;

  const [hoursRaw, minutes = "00"] = raw.split(":");
  const hours = Number(hoursRaw);
  if (Number.isNaN(hours)) return raw;

  const suffix = hours >= 12 ? "PM" : "AM";
  const formattedHour = ((hours + 11) % 12) + 1;
  return `${formattedHour}:${minutes.padStart(2, "0")} ${suffix}`;
}

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_time_picker = _resolveComponent("v-time-picker")!
  const _component_v_menu = _resolveComponent("v-menu")!
  const _component_v_text_field = _resolveComponent("v-text-field")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (__props.label)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (__props.labelIcon)
            ? (_openBlock(), _createBlock(_component_v_icon, {
                key: 0,
                size: "18"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(__props.labelIcon), 1)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createElementVNode("span", null, _toDisplayString(__props.label), 1)
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_v_text_field, _mergeProps({
      "model-value": displayValue.value,
      class: fieldClass.value,
      variant: __props.variant,
      flat: __props.flat,
      "hide-details": __props.hideDetails,
      readonly: ""
    }, fieldAttrs.value), {
      default: _withCtx(() => [
        _createVNode(_component_v_menu, {
          modelValue: showMenu.value,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((showMenu).value = $event)),
          activator: "parent",
          "close-on-content-click": false,
          "min-width": "0"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_time_picker, {
              modelValue: model.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((model).value = $event))
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _: 1
    }, 16, ["model-value", "class", "variant", "flat", "hide-details"])
  ]))
}
}

})